import React, { useMemo, useState } from 'react';
import { Scale } from 'lucide-react';
import { Heading } from '../../layout';
import { useUIColors } from '../../../hooks/useTheme';
import { PATENT_STATUSES, PHENOX_PATENTS } from './ipCatalog';

const PatentsWorkspace = ({ isDarkMode = false }) => {
  const ui = useUIColors();
  const [status, setStatus] = useState('Todas');

  const items = useMemo(
    () => PHENOX_PATENTS.filter((item) => status === 'Todas' || item.status === status),
    [status]
  );

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      <div>
        <Heading level={2} isDarkMode={isDarkMode}>
          <Scale size={22} style={{ marginRight: 8, verticalAlign: 'middle' }} />
          Patentes
        </Heading>
        <p style={{ margin: '6px 0 0', fontSize: 13, color: ui.muted }}>
          Familia de solicitudes y extensiones que cubren la plataforma PhenoX® y sus grados.
        </p>
      </div>

      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {PATENT_STATUSES.map((item) => {
          const active = status === item;
          return (
            <button
              key={item}
              type="button"
              onClick={() => setStatus(item)}
              style={{
                height: 30,
                padding: '0 12px',
                borderRadius: 999,
                border: `1px solid ${active ? ui.interactive || '#16a34a' : ui.border}`,
                background: active ? ui.interactive || '#16a34a' : 'transparent',
                color: active ? ui.textOnAccent || '#fff' : ui.text,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {item}
            </button>
          );
        })}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 14,
        }}
      >
        {items.map((item) => (
          <article
            key={item.id}
            style={{
              border: `1px solid ${ui.border}`,
              borderRadius: 14,
              background: ui.panel,
              padding: 16,
              display: 'grid',
              gap: 10,
              minWidth: 0,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: ui.muted }}>{item.code}</div>
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  padding: '4px 8px',
                  borderRadius: 999,
                  background: isDarkMode ? '#2e1065' : '#f3e8ff',
                  color: isDarkMode ? '#d8b4fe' : '#7c3aed',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.status}
              </span>
            </div>
            <h3 style={{ margin: 0, fontSize: 16, color: ui.text }}>{item.title}</h3>
            <div style={{ fontSize: 12, color: ui.muted }}>{item.family}</div>
            <p style={{ margin: 0, fontSize: 13, color: ui.muted, lineHeight: 1.45 }}>{item.summary}</p>
            <div style={{ fontSize: 12, color: ui.text }}>
              <strong>Territorios:</strong> {item.territories}
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 700, color: ui.muted, marginBottom: 6 }}>Cubre</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {item.covers.map((cover) => (
                  <span
                    key={cover}
                    style={{
                      fontSize: 11,
                      padding: '3px 8px',
                      borderRadius: 999,
                      border: `1px solid ${ui.border}`,
                      color: ui.text,
                    }}
                  >
                    {cover}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default PatentsWorkspace;
